module.exports = __webpack_public_path__ + "img/middle_corner.7bd0e09.png";